import { useState, useMemo } from "react";
import { api } from "../../services/api";

function MoveProductPanel({ product, allProducts, onClose, onProductMoved }) {
  const companies = useMemo(() => {
    const map = {};
    allProducts.forEach(p => {
      if (!map[p.Company]) map[p.Company] = new Set();
      map[p.Company].add(p.Line);
    });
    return map;
  }, [allProducts]);

  const [company, setCompany] = useState("");
  const [line, setLine] = useState("");
  const [loading, setLoading] = useState(false);

  const lines = company ? Array.from(companies[company] || []) : [];

  const handleMove = async () => {
    if (!company || !line) return;

    const target = allProducts.find(
      p => p.Company === company && p.Line === line
    );

    if (!target) return;

    setLoading(true);
    try {
      await api.post("/products/move", {
        productId: product.IdNumber,
        newCompanyId: target.CompanyId,
        newLineId: target.LineId,
      });

      onClose();          // close panel
    onProductMoved();
    } catch (err) {
      console.error("Move failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed top-20 right-6 w-80 bg-white shadow-2xl rounded-xl border z-50">
      <div className="p-4 border-b flex justify-between items-center">
        <h3 className="font-semibold text-slate-700">Move Product</h3>
        <button
          onClick={onClose}
          className="text-slate-400 hover:text-red-500"
        >
          ✕
        </button>
      </div>

      <div className="p-4 space-y-4">
        <div>
          <div className="text-sm text-slate-500 mb-1">Product</div>
          <div className="font-medium text-slate-800">
            {product.Name}
          </div>
        </div>

        <select
          value={company}
          onChange={e => {
            setCompany(e.target.value);
            setLine("");
          }}
          className="w-full border rounded px-3 py-2"
        >
          <option value="">Select Company</option>
          {Object.keys(companies).map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>

        <select
          value={line}
          onChange={e => setLine(e.target.value)}
          disabled={!company}
          className="w-full border rounded px-3 py-2 disabled:opacity-50"
        >
          <option value="">Select Line</option>
          {lines.map(l => (
            <option key={l} value={l}>{l}</option>
          ))}
        </select>

        <button
          onClick={handleMove}
          disabled={!company || !line || loading}
          className="w-full py-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded disabled:opacity-40"
        >
          {loading ? "Moving..." : "Move Product"}
        </button>
      </div>
    </div>
  );
}

export default MoveProductPanel;
